export const WEEE_SYSTEM = 'WEEESYSTEM';
export const COUNTRY = 'COUNTRY';
export const UNU_KEYS = 'UNU-keys';
export const KF_CATEGORIES = 'kf-categories';
export const COLLECTION_STREAMS = 'collection-streams';
export const REGIONS = [
  {value: 'EU', name: 'EUROPE'},
  {value: 'AFRICA', name: 'AFRICA'},
  {value: 'ASIA', name: 'ASIA'},
  {value: 'NORTH_AMERICA', name: 'NORTH AMERICA'},
  {value: 'LATIN_AMERICA', name: 'LATIN AMERICA'},
  {value: 'OCEANIA', name: 'OCEANIA'},
];
